<style src="./SuggestEvent.scss" lang="scss" scoped></style>
<template>
  <input-suggest
    :label="label"
    :placeholder="placeholder"
    v-model="inputValue"
    :rules="rules"
    min="2">

    <input-suggest-item
      v-for="(item, idx) in suggestionList"
      :key="idx"
      :idx="idx"
      :item="item"
      class="client-item">

      <div class="client-row-top">
        <span class="short-name">{{ item.client.shortName }}</span>
        <span class="full-name">{{ item.identification }}</span>
      </div>
    </input-suggest-item>
  </input-suggest>
</template>
<script>
import { InputSuggest, InputSuggestMixin, InputSuggestItem } from '@/components/primitives/input-suggest'
import { IconCalendar, IconGenderFemale, IconUser, IconCard } from '@/components/primitives/icons'
import GetEventList from '@/brain/event/ListEvent'

export default {
  name: 'SuggestEvent',
  mixins: [InputSuggestMixin],
  components: {
    InputSuggest,
    InputSuggestItem,
    IconCalendar,
    IconGenderFemale,
    IconCard,
    IconUser
  },
  data () {
    return {
      captionRaw: 'shortName'
    }
  },
  methods: {
    async doSearch (pSearchTerm) {
      const params = {
        filters: {
          searchText: pSearchTerm
        }
      }
      const { list } = await GetEventList({ params })
      return list
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/suggest/suggest-event/SuggestEvent.vue